export default {


    methods: {

        currencyExchangePriceDown(price, lang, currency_type = null) {

            let value = '';
            if (currency_type === null) {

                if (lang == 'ja') {
                    value = price + '円';
                } else if (lang == 'en') {
                    //  value = '$' + String(Math.floor(price / 100));
                    value = '$' + String(Math.floor(price / 100));
                } else {
                    value = '-';
                }
            }
            return value;
        },

        currencyExchange(price, lang, currency_type = null) {

            let value = '';
            if (currency_type === null) {

                if (lang == 'ja') {
                    value = price + '円';
                } else if (lang == 'en') {
                    //  value = '$' + String(Math.floor(price / 100));
                    value = '$' + String(Math.floor(price));
                } else {
                    value = '-';
                }
            } else {
                if (lang == 'ja') {

                    if (currency_type == 'JPY') {
                        value = price + '円';
                    } else if (currency_type == 'USD') {
                        value = String(Math.floor(price)) + 'ドル';
                    }
                } else if (lang == 'en') {

                    if (currency_type == 'JPY') {
                        value = '$' + String(Math.floor(price / 100));
                    } else if (currency_type == 'USD') {
                        value = '$' + String(Math.floor(price));
                    }
                } else {
                    value = '-';
                }
            }
            return value;
        },






        currencyExchangeReview(price, raw_lang, lang) {
            let value = '';
            if (price == 0) {
                return value;
            }
            if (lang == 'ja') {
                if (raw_lang == 'ja') {
                    value = price + '円';
                } else if (raw_lang == 'en') {
                    value = price + 'ドル';
                }
            } else if (lang == 'en') {
                if (raw_lang == 'ja') {
                    value = '￥' + price;
                } else if (raw_lang == 'en') {
                    value = '$' + price;
                }
            } else {
                value = '';
            }

            return value;
        },
        newOldEtcChange(new_old, lang) {
            let value = '';
            if (lang == 'ja') {
                if (new_old == "New") {
                    value = '新品';
                } else if (new_old == "Used") {
                    value = '中古';
                } else if (new_old == "Etc") {
                    value = 'その他';
                } else {
                    value = '';
                }

            } else if (lang == 'en') {
                if (new_old == "New") {
                    value = 'New';
                } else if (new_old == "Used") {
                    value = 'Used';
                } else if (new_old == "Etc") {
                    value = 'Etc';
                } else {
                    value = '';
                }
            } else {
                if (new_old == "New") {
                    value = 'New';
                } else if (new_old == "Used") {
                    value = 'Used';
                } else if (new_old == "Etc") {
                    value = 'Etc';
                } else {
                    value = '';
                }
            }

            return value;
        },
    },

};
